import { useState, type FormEvent } from "react";
import { navItems } from "@/mocks/home";

export default function SiteNavbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [hint, setHint] = useState("");

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = query.trim();
    if (!keyword) {
      setHint("先输入想找的关键词，比如“今天刚出”");
      return;
    }
    setHint(`「${keyword}」的相关更新正在整理，稍后补上`);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-10">
        <div className="flex h-16 items-center justify-between gap-4">
          <a href="#top" className="flex shrink-0 items-center gap-2.5" aria-label="黑料视频首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-lg font-bold">
              料
            </span>
            <h1 className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                黑料视频
              </span>
              <span className="mt-0.5 text-[11px] font-normal tracking-wide text-foreground-500">
                今天刚出的都在这
              </span>
            </h1>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.anchor}
                href={`#${item.anchor}`}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 md:flex">
            <form onSubmit={handleSearch} className="relative">
              <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
                <i className="ri-search-line text-sm"></i>
              </span>
              <input
                type="text"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="搜索今天刚出的"
                className="h-9 w-44 rounded-md border border-background-300 bg-background-100/70 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 lg:w-52"
              />
              <button
                type="submit"
                className="absolute right-1 top-1/2 flex h-7 -translate-y-1/2 cursor-pointer items-center justify-center rounded bg-secondary-500 px-2 text-xs font-medium text-background-50 transition-colors hover:bg-secondary-600"
              >
                搜
              </button>
            </form>
            <a
              href="#topic"
              className="flex h-9 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-notification-3-line text-base"></i>
              更新提醒
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label="展开导航"
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-4-line text-xl"}></i>
          </button>
        </div>

        {hint && (
          <p className="pb-2 text-xs text-foreground-500">{hint}</p>
        )}
      </div>

      {mobileOpen && (
        <div className="w-full border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <div className="flex flex-wrap gap-2">
            {navItems.map((item) => (
              <a
                key={item.anchor}
                href={`#${item.anchor}`}
                onClick={() => setMobileOpen(false)}
                className="rounded-md border border-background-200 bg-background-100 px-3 py-2 text-sm font-medium text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </div>
          <form onSubmit={handleSearch} className="relative mt-3">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm"></i>
            </span>
            <input
              type="text"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="搜索今天刚出的"
              className="h-10 w-full rounded-md border border-background-300 bg-background-100/70 pl-9 pr-16 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400"
            />
            <button
              type="submit"
              className="absolute right-1 top-1/2 flex h-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded bg-secondary-500 px-3 text-sm font-medium text-background-50"
            >
              搜索
            </button>
          </form>
        </div>
      )}
    </header>
  );
}